export default __webpack_public_path__ + "static/media/DNo.28-0.37e924a8.jpg";